// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Dashboard from './Dashboard';
import DocumentForm from './DocumentForm';
import LoginPage from './LoginPage';
import AdminRoute from './AdminRoute';
import ProtectedRoute from './ProtectedRoute';
import MainLayout from './MainLayout'; 

// (อัปเกรด) Import หน้า Admin ทั้งหมด
import AdminDashboard from './AdminDashboard';
import UserManagement from './UserManagement';
import AnnouncementManagement from './AnnouncementManagement';
import DocumentManagement from './DocumentManagement';
import DocumentTable from './DocumentTable';
import CategoryManagement from './CategoryManagement';
import TagManagement from './TagManagement';
import FeaturedManagement from './FeaturedManagement';
import FeedHub from './FeedHub'; // (1. Import Hub)
import AgencyManagement from './AgencyManagement'; // (2. Import Agency)
import TopicManagement from './TopicManagement'; // (3. Import Topic)
import MinistryManagement from './MinistryManagement';

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        
        <Route path="/login" element={<LoginPage />} />

        <Route element={<MainLayout />}>
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Dashboard />} />
            {/* (ถ้ามีหน้าอื่นๆ ที่ User ทั่วไปเข้าได้ ก็วางไว้ตรงนี้) */}
          </Route>

          
          <Route element={<AdminRoute />}>
            <Route path="/new" element={<DocumentForm />} />
            <Route path="/edit/:id" element={<DocumentForm />} />
            
            {/* (Admin Hubs) */}
            <Route path="/admin" element={<AdminDashboard />} /> 
            <Route path="/admin/documents" element={<DocumentManagement />} />
            
            {/* (หน้าจัดการ KB) */}
            <Route path="/admin/documents/all" element={<DocumentTable />} />
            <Route path="/admin/categories" element={<CategoryManagement />} />
            <Route path="/admin/tags" element={<TagManagement />} />
            
            {/* (หน้าจัดการ Site) */}
            <Route path="/admin/users" element={<UserManagement />} /> 
            <Route path="/admin/announcements" element={<AnnouncementManagement />} />
            <Route path="/admin/featured" element={<FeaturedManagement />} />
            
            {/* --- ▼▼▼ (แก้ไข 3 Routes) ▼▼▼ --- */}
            <Route path="/admin/feeds" element={<FeedHub />} />
            <Route path="/admin/feeds/ministries" element={<MinistryManagement />} />
            <Route path="/admin/feeds/agencies" element={<AgencyManagement />} /> {/* (เพิ่มบรรทัดที่หายไป) */}
            <Route path="/admin/feeds/topics" element={<TopicManagement />} />
            {/* --- ▲▲▲ (สิ้นสุดการแก้ไข) ▲▲▲ --- */}

          </Route>
        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;